export const SIGN_IN = '/sign-in';
export const DASHBOARD = '/dashboard';
export const Terms = '/terms';
export const Privacy = '/privacy';
export const AvailableRoutes = ['/sign-in', '/dashboard', '/terms', '/privacy'];
